import { FC } from 'react';

const NotHappy: FC<{ filled?: boolean }> = ({ filled }) => {
    const color = filled ? '#FF0C3E' : '#BDBDBD';

    return (
        <svg
            width="50"
            height="50"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_1438_5180)">
                <path
                    d="M25 49.2789C11.6186 49.2789 0.721191 38.3815 0.721191 25.0001C0.721191 11.6187 11.6186 0.641113 25 0.641113C38.3815 0.641113 49.2789 11.5385 49.2789 24.92C49.2789 38.3014 38.3815 49.2789 25 49.2789ZM25 3.84624C13.3814 3.84624 3.84619 13.3815 3.84619 25.0001C3.84619 36.6187 13.3013 46.0738 24.9199 46.0738C36.5385 46.0738 45.9936 36.6187 45.9936 25.0001C45.9936 13.3815 36.6186 3.84624 25 3.84624Z"
                    fill={color}
                />
                <path
                    d="M36.378 38.3815C35.6569 38.3815 35.0158 37.9007 34.8556 37.1796C34.7755 36.9392 33.0126 30.4488 25.4005 30.4488H24.9998C17.3075 30.4488 15.6248 36.859 15.5447 37.1796C15.3043 38.061 14.4229 38.5417 13.6216 38.3815C12.7402 38.1411 12.2594 37.2597 12.4197 36.4584C13.221 33.2533 16.8267 27.2437 24.9998 27.2437H25.4005C33.4934 27.2437 37.1793 33.2533 37.9005 36.3783C38.1408 37.2597 37.58 38.1411 36.6985 38.3013C36.6184 38.3815 36.4582 38.3815 36.378 38.3815Z"
                    fill={color}
                />
                <path
                    d="M16.5867 23.077C18.1356 23.077 19.3912 21.8214 19.3912 20.2725C19.3912 18.7236 18.1356 17.468 16.5867 17.468C15.0378 17.468 13.7822 18.7236 13.7822 20.2725C13.7822 21.8214 15.0378 23.077 16.5867 23.077Z"
                    fill={color}
                />
                <path
                    d="M33.1731 23.077C34.722 23.077 35.9776 21.8214 35.9776 20.2725C35.9776 18.7236 34.722 17.468 33.1731 17.468C31.6243 17.468 30.3687 18.7236 30.3687 20.2725C30.3687 21.8214 31.6243 23.077 33.1731 23.077Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_1438_5180">
                    <rect width="50" height="50" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default NotHappy;
